<div class="">
    <h1 class="fs-28 text-brightPurple mb-3">Projected Implementation dates</h1>
    <p class="fs-16 text-secondary mb-3 mb-lg-4">
        Please select Projected Start and End Month / Year for {{ userService.getRecommendationTitle(recommendation?.category) }}
    </p>

    <form action="" [formGroup]="projectForm">
        <div class="row mb-2">
            <div class="col-sm-4 align-self-center">
                <label for="startDate" class="fs-16 fw400 form-label mb-1">Start date:</label>
            </div>
            <div class="col-sm-8">
                <app-month-picker formControlName="startDate" [dateType]="'start'" [max]="projectForm.value.endDate" ></app-month-picker>
            </div>
        </div>   
        <div class="row mb-2">
            <div class="col-sm-4 align-self-center">
                <label for="endDate" class="fs-16 fw400 form-label mb-1">End date:</label>
            </div>
            <div class="col-sm-8">
                <app-month-picker formControlName="endDate" [dateType]="'end'" [min]="projectForm.value.startDate"></app-month-picker>
            </div>
        </div>  
    </form>

    <div class="d-grid d-md-flex justify-content-md-end gap-3 mt-4">
        <button [disabled]="isLoading" type="button" class="GA-registerClose btn-secondary" (click)="close()">
            Close
        </button>
        <button [disabled]="isLoading || projectForm.invalid"
            type="button" class="GA-resetLink btn-primary" (click)="saveChanges()">
            Save
        </button>
    </div>
</div>